import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { ManageSCTAddComponent } from "./manage-sctadd/manage-sctadd.component";
import { ManageSCTEditComponent } from "./manage-sctedit/manage-sctedit.component";

@Component({
	selector: "caass-manage-school-container-table",
	templateUrl: "./manage-school-container-table.component.html",
	styleUrls: ["./manage-school-container-table.component.css"],
})
export class ManageSchoolContainerTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {
		//Get Data from DB
		this.loadContainerList();
	}

	ngOnChanges() {
		// if(this.GotoFirst == 0){
		//   this.GotoFirst = Number(this.pagefirst);
		// }

		this.loadContainerList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	@Input() UpdateSchoolCount: any;
	@Output() ContainerSelected: EventEmitter<any> = new EventEmitter();

	//Table Data
	lstContainers: any = [];
	SelectedContainer: any;

	lstActive: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	// GotoFirst: any = 0;

	cols = [
		{ field: "SchoolGroupCD", header: "Code" },
		{ field: "SchoolGroupDesc", header: "Name" },
		{ field: "SchoolsCount", header: "Schools" },
		{ field: "Active", header: "Status" },
	];

	ToggleText: any = "Deactivate";
	errorMessage: any = "";

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadContainerList() {
		this.loading = true;

		var result = this.sysAdminService.UserGroupGetAllContainers(2);
		result.subscribe(
			(response) => {
				this.lstContainers = response;

				for (var i = 0; i < this.lstContainers.length; i++) {
					var next = this.lstContainers[i];

					next.Active = next.Active == 1 ? "Active" : "Inactive";
				}

				this.lstActive = Array.from(new Set(this.lstContainers.map((item: any) => item.Active))).sort();

				this.loading = false;

				// if(this.GotoFirst != 0){
				//   this.pagefirst = Number(this.GotoFirst);
				//   this.GotoFirst = 0;
				// }
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ManageSCTAddComponent, {
			header: "Add School Container",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadContainerList();
			}
		});
	}

	onRowDblClick(container) {
		this.SelectedContainer = container;
		this.onEdit();
	}

	onEdit() {
		this.errorMessage = "";

		//Error Handling
		if (this.SelectedContainer == undefined || this.SelectedContainer == null) {
			this.errorMessage = "Select a School Container to edit";
			return;
		}

		var ref = this.dialogService.open(ManageSCTEditComponent, {
			header: "Edit School Container",
			width: "fit-content",
			data: {
				SelectedContainer: this.SelectedContainer,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadContainerList();
				this.onRowUnselect(null);
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error Handling
		if (this.SelectedContainer == undefined || this.SelectedContainer == null) {
			this.errorMessage = "Select a School Container to toggle";
			return;
		}

		var active = this.SelectedContainer.Active == "Active" ? 0 : 1;

		var result = this.sysAdminService.SchoolGroupActivate(this.SelectedContainer.SchoolGroupID, active);
		result.subscribe(
			(response) => {
				this.loadContainerList();
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedContainer = val.data;

		this.ToggleText = "Deactivate";
		if (this.SelectedContainer.Active == "Inactive") {
			this.ToggleText = "Activate";
		}

		this.errorMessage = "";

		this.ContainerSelected.emit(this.SelectedContainer);
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedContainer = null;

		this.ToggleText = "Deactivate";

		this.ContainerSelected.emit(this.SelectedContainer);
	}
	///////////////////////////////////////////////////////
}
